<template>
    <div class="rounded-md shadow-2xs">
        <Select
            :model-value="modelValue"
            name="HeartrateUpload"
            :label="$t('heartrate.polar-recording-label')"
            :empty-option-label="$t('form.none')"
            @update:model-value="emits('update:modelValue', $event)"
        >
            <option v-for="upload in uploads" :key="upload.id" :value="upload.id">
                {{ heartrateUploadLabel(upload, locale) }}
            </option>
        </Select>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { heartrateUploadLabel } from '@/lib/sessions/heartrate-uploads'

import Select from '@/components/form/Select.vue'

// P7: the Polar captures kept on the server a session or a MOVE PRO file may
// read (lib/sessions/heartrate-uploads.js), plus « Aucun ».
defineProps({
    modelValue: { type: [String, Number, null], default: '' },
    uploads: { type: Array, default: () => [] },
})

const emits = defineEmits(['update:modelValue'])
const { locale } = useI18n()
</script>
